import React, { useState } from 'react';
import { IoInformationCircle } from "react-icons/io5";
import { TbListDetails } from "react-icons/tb";
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import { FaPencilAlt } from "react-icons/fa";
import Alert from 'react-bootstrap/Alert';
import { useNavigate } from 'react-router-dom';

export default function AddAnnouncements() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    message: '',
    category: ''
  });

  const [options] = useState([
    { value: '', label: '--Select--' },
    { value: 'All', label: 'All' },
    { value: 'HR', label: 'HR' },
    { value: 'Employee', label: 'Employee' },
    { value: 'Accounts', label: 'Accounts' }
  ]);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('success');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSelectChange = (selectedOption) => {
    setFormData({
      ...formData,
      category: selectedOption ? selectedOption.value : ''
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Retrieve the role (author) from localStorage
    const author = localStorage.getItem('role'); // Ensure 'role' is stored in localStorage

    if (!author) {
      setAlertMessage('Author role is missing. Please log in again.');
      setAlertVariant('danger');
      setShowAlert(true);
      return;
    }

    try {
      const response = await fetch('https://backend.ems.hiradentallab.com/api/announcements/add-announcements', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: formData.title,
          content: formData.message,
          category: formData.category,
          author, // Include author in the request body
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to add announcement');
      }

      setAlertMessage('Announcement added successfully!');
      setAlertVariant('success');
      setShowAlert(true);

      // Reset form fields after successful submission
      setFormData({
        title: '',
        message: '',
        category: ''
      });

      // Redirect to the announcements page
      navigate('/emp-announcements');
    } catch (error) {
      console.error('Error details:', error);
      setAlertMessage(error.message);
      setAlertVariant('danger');
      setShowAlert(true);
    }
  };

  return (
    <div className='container-fluid'>
      <h1 style={{ marginTop: '60px', fontSize: '2rem', color: '#0353a4' }}>
        <IoInformationCircle className="salary-icon" /> Announcements Information
      </h1>
      <hr />
      <h2 className="salary-subtitle">
        <TbListDetails className="salary-icon" /> Announcements Details
      </h2>
      <hr />
      <div className="table-container">
        {showAlert && (
          <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
            {alertMessage}
          </Alert>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="title" style={{ fontWeight: 'bold' }}>
              Announcement Title <span style={{ color: 'red' }}> *</span>
            </label>
            <input
              type="text"
              id="title"
              name="title"
              className="form-control"
              value={formData.title}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message" style={{ fontWeight: 'bold' }}>
              Announcement Message <span style={{ color: 'red' }}> *</span>
            </label>
            <textarea
              id="message"
              name="message"
              className="form-control"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="category" style={{ fontWeight: 'bold' }}>
              Announcement For <span style={{ color: 'red' }}> *</span>
            </label>
            <Select
              id="category"
              options={options}
              onChange={handleSelectChange}
              value={options.find(option => option.value === formData.category)}
              isClearable
              placeholder="--Select--"
            />
          </div>
          <div className="py-3">
            <Button variant="primary" type="submit">
              <FaPencilAlt /> Add Announcement
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}